// extracted by mini-css-extract-plugin
export default {"container":"styles_container__3xrti","title":"styles_title__JBlOA","action":"styles_action__i4Y6U","image":"styles_image__-0Zue"};